module.exports = __webpack_public_path__ + "img/78815958000128.81d3c2cd.png";